function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 16,
  cy: 16,
  r: 16,
  fill: "#F9F7F6"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M20.7271 12.617C20.7508 12.4244 20.7632 12.2283 20.7632 12.0292C20.7632 10.3562 19.407 9 17.734 9H12.6715C12.353 9 12.0812 9.22996 12.0283 9.54398L10.1629 20.6312C10.096 21.029 10.4027 21.3916 10.8061 21.3916H12.6576C12.976 21.3916 13.253 21.1618 13.3058 20.8477C13.3058 20.8477 13.3089 20.8293 13.3145 20.7962H13.3145L13.0565 22.3298C12.9975 22.6804 13.2678 23 13.6234 23H15.2431C15.5238 23 15.7635 22.7973 15.81 22.5205L16.2702 19.7856C16.3495 19.3141 16.7576 18.9689 17.2357 18.9689H17.6612C19.9726 18.9689 21.8463 17.0952 21.8463 14.7839C21.8463 13.8895 21.4042 13.0989 20.7271 12.617Z",
  fill: "#002987"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M20.7271 12.617C20.4374 14.9735 18.429 16.7982 15.9943 16.7982H14.5816C14.2627 16.7982 13.9873 17.0105 13.9009 17.3108L13.0565 22.3298C12.9975 22.6804 13.2678 23 13.6234 23H15.2431C15.5238 23 15.7635 22.7973 15.81 22.5205L16.2702 19.7856C16.3495 19.3141 16.7577 18.9689 17.2357 18.9689H17.6612C19.9726 18.9689 21.8463 17.0952 21.8463 14.7839C21.8463 13.8895 21.4042 13.0989 20.7271 12.617Z",
  fill: "#0085CC"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M14.5815 16.7981H15.9942C18.429 16.7981 20.4374 14.9735 20.7271 12.617C20.2926 12.3079 19.7617 12.1255 19.1879 12.1255H15.5006C15.0808 12.1255 14.7223 12.4286 14.6527 12.8426L13.9009 17.3108C13.9873 17.0105 14.2627 16.7981 14.5815 16.7981Z",
  fill: "#00186A"
});

function SvgPaypalBillingIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaypalBillingIcon);
export default __webpack_public_path__ + "static/media/paypal-billing-icon.f0dda1dc.svg";
export { ForwardRef as ReactComponent };